export default __webpack_public_path__ + "img/allergy-gluten.b166251ee8054a394d72a630885c0003.svg";